module.exports = __webpack_public_path__ + "static/media/daotu22.4e292901.jpg";